import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { OtPosition } from "./PositionStats";
import { AreaChart } from "@mantine/charts";
import _ from "lodash";
import { useViewportSize } from "@mantine/hooks";
import PaperBlocks2 from "./PaperBlocks2";

interface Props {
    opening: OtPosition;
}

const AverageEvalStats: React.FC<Props> = ({ opening }) => {
    const { width } = useViewportSize();
    const [movingAverageWindow, setMovingAverageWindow] = useState(
        Math.min(20, Math.ceil(opening.OtAttempt2.length / 2))
    );

    const evalDataPointsMA = opening.OtAttempt2?.map((attempt, index, array) => {
        const evals = array.slice(index, index + movingAverageWindow).map((a) => parseFloat(a.evaluation));
        const avg =
            evals.reduce((a, b) => {
                b = Math.min(10, Math.max(-9.75, b));
                return a + b;
            }, 0) / evals.length;
        return {
            date: dayjs(attempt.createdAt).format("D. MMM"),
            eval: Math.round(avg * 10) / 10,
        };
    }).slice(0, -movingAverageWindow + 1);

    const isMobile = width < 520;

    useEffect(() => {
        setMovingAverageWindow(Math.min(20, Math.ceil(opening.OtAttempt2.length / 2)));
    }, [opening]);

    return (
        <div className="flex space-x-10 [@media(max-width:900px)]:flex-col [@media(max-width:900px)]:space-y-12 [@media(max-width:900px)]:items-center [@media(max-width:900px)]:space-x-0">
            {!_.isEmpty(evalDataPointsMA) && (
                <div className="flex justify-center">
                    <AreaChart
                        strokeWidth={3}
                        h={isMobile ? 370 : 500}
                        w={isMobile ? 370 : 500}
                        data={evalDataPointsMA}
                        dataKey="date"
                        series={[{ name: "eval", color: "indigo.6" }]}
                        curveType="linear"
                        areaProps={{ isAnimationActive: true }}
                        gridAxis="x"
                        xAxisProps={{ interval: Math.floor(evalDataPointsMA.length / 5) }}
                        withDots={evalDataPointsMA.length <= 15}
                    />
                </div>
            )}
            <PaperBlocks2
                opening={opening}
                setMovingAverageWindow={setMovingAverageWindow}
                movingAverageWindow={movingAverageWindow}
            />
        </div>
    );
};

export default AverageEvalStats;
